import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { colors } from '../theme';

export default function Footer() {
  return (
    <Box component="footer" sx={{ backgroundColor: colors.white, borderTop: `1px solid ${colors.grayBorder}` }}>
      <Container sx={{ py: { xs: 5, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          spacing={2}
        >
          <Box>
            <Stack direction="row" spacing={1.5} alignItems="center" sx={{ flexWrap: 'wrap' }}>
              <Link href="/privacy" color="text.secondary" underline="hover" sx={{ fontSize: '0.9rem' }}>
                Privacy Policy
              </Link>
              <Typography sx={{ color: colors.grayBorder }}>•</Typography>
              <Link href="/terms" color="text.secondary" underline="hover" sx={{ fontSize: '0.9rem' }}>
                Terms of Service
              </Link>
            </Stack>
            <Typography variant="body2" sx={{ color: colors.inkSoft, mt: 1 }}>
              Copyright © {new Date().getFullYear()} Adrian Chesnoiu. All rights reserved.
            </Typography>
          </Box>

          <IconButton
            href="https://www.linkedin.com/in/adrian-mihai-chesnoiu-11a3578b/"
            target="_blank"
            rel="noopener"
            aria-label="LinkedIn"
            sx={{ color: colors.inkSoft, '&:hover': { color: colors.blue } }}
          >
            <LinkedInIcon />
          </IconButton>
        </Stack>
      </Container>
    </Box>
  );
}
